import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import SpaceBetweenOrg from "../../organisms/SpaceBetweenOrg";
import LinkQuark from "../../quarks/Link";
import Picture from "../../quarks/Picture";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a1 1 0 0 1 1-1h20v2H1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.752 3.168a1 1 0 0 1 0 1.664l-3.197 2.13A1 1 0 0 1 21 6.131V1.87a1 1 0 0 1 1.555-.832l3.197 2.13z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "8"
};
import { LinkTypes } from "./index";
var layoutBreakpointValue = "large";
export var TileMolArrow = styled(ArrowSvg).withConfig({
  componentId: "sc-1r77fda-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";fill:", ";"], transition("transform"), getColor(theme, "primary"));
});
export var TileMolImageWrapper = styled.div.withConfig({
  componentId: "sc-1r77fda-1"
})(["flex-shrink:0;width:", ";overflow:hidden;"], space(28));
export var TileMolImage = styled(Picture).withConfig({
  componentId: "sc-1r77fda-2"
})(["", ";width:100%;height:100%;object-fit:cover;"], transition("transform"));
export var TileMolWrapper = styled.div.withConfig({
  componentId: "sc-1r77fda-3"
})(function (_ref2) {
  var $hasArrow = _ref2.$hasArrow,
    $onColor = _ref2.$onColor,
    $backgroundColor = _ref2.$backgroundColor,
    $isReversed = _ref2.$isReversed,
    $linkType = _ref2.$linkType,
    theme = _ref2.theme;
  return css(["", ";position:relative;overflow:hidden;border-radius:", ";background-color:", ";box-shadow:", ";", "{display:flex;flex-direction:", ";}", " ", ""], transition("box-shadow"), getBorderRadius(theme, "large"), getColor(theme, $backgroundColor), getBoxShadow(theme, "small"), breakpoint(layoutBreakpointValue), $isReversed ? "row-reverse" : "row", $linkType === LinkTypes.LINK && css(["&:hover{box-shadow:", ";", "{transform:scale(1.2);}", "}"], getBoxShadow(theme, "medium"), TileMolImage, $hasArrow && css(["", "{transform:translateX(", ");}"], TileMolArrow, space(1))), $hasArrow && css(["border:", " solid ", ";"], unit(1), getBorderColor(theme, $onColor, "low")));
});
export var ContentWrapper = styled.div.withConfig({
  componentId: "sc-1r77fda-4"
})(["padding:", ";", "{display:flex;flex:1;flex-direction:column;justify-content:space-between;}"], space(4), breakpoint(layoutBreakpointValue));
export var TextContainer = styled.div.withConfig({
  componentId: "sc-1r77fda-5"
})(["margin-bottom:", ";"], space(6));
export var FooterWithArrow = styled(SpaceBetweenOrg).withConfig({
  componentId: "sc-1r77fda-6"
})(["align-items:center;"]);
export var TileMolLinkBox = styled(LinkQuark).withConfig({
  componentId: "sc-1r77fda-7"
})(function (_ref3) {
  var $hasPrimaryColor = _ref3.$hasPrimaryColor,
    theme = _ref3.theme;
  return css(["color:inherit;text-decoration:none;&::before{", ";content:\"\";z-index:1;}", ""], cover(), $hasPrimaryColor ? css(["> *{color:", ";}"], getColor(theme, "primary")) : null);
});